export enum AuthAtionTypes {
  LOAD_AUTH = 'auth/LOAD_AUTH',
  LOAD_AUTH_SUCCESS = 'auth/LOAD_AUTH_SUCCESS',
  LOAD_AUTH_FAILED = 'auth/LOAD_AUTH_FAILED',
  LOGOUT = 'auth/LOGOUT',
  SET_MESS_AUTH_ERR = 'auth/SET_MESS_AUTH_ERR',
  UPDATE_PROFILE = 'auth/UPDATE_PROFILE',
}
